app.controller('patientCreateController', ['$scope', '$state', '$mdDialog', '$translate', 'objectHelper', 'baseModel', 'applicationModel', 'patientModel', 'userModel', 'dictionaryModel', 'nfzOfficeModel',
    function ($scope, $state, $mdDialog, $translate, objectHelper, baseModel, applicationModel, patientModel, userModel, dictionaryModel, nfzOfficeModel) {

        function setData() {
            $scope.patientCorespondenceCheckbox = false;
            $scope.citizenshipList = null;
            $scope.stateList = null;
            $scope.patient = new PatientVO();
            $scope.patient.registeredAddress = new AddressVO();
            $scope.patient.authorizedPersons = [];
            $scope.patient.attachments = [];
            $scope.patient.birthDate = new Date();
            $scope.patient.identityDocumentType = Enum.IDENTITY_DOCUMENT_TYPE.ID;
            $scope.patient.correspondenceAddressSameAsRegisteredAddress = false;

            $scope.forms = {
                personalData: null
            };

            $scope.genderTypes = Object.keys(Enum.GENDER);
            $scope.identityDocumentTypes = Object.keys(Enum.IDENTITY_DOCUMENT_TYPE);

            $scope.presentDate = new Date();
            $scope.fileList = [];

        }

        function setPermissions() {
        }

        function setListeners() {
            $scope.$on('$destroy', function (event) {
                applicationModel.viewReady = false;
            });

            $scope.$on(Event.DICTIONARY.GET_DICTIONARY_ELEMENT_DATA_PAGE.SUCCESS, function (event, dataPage, code) {
                if(code === Constant.DICTIONARY_CODE.CITIZENSHIP) {
                    $scope.citizenshipList = dataPage.data;
                }
                if(code === Constant.DICTIONARY_CODE.STATE) {
                    $scope.stateList = dataPage.data;
                }
            });

            $scope.$on(Event.PATIENT.SAVE.SUCCESS, function() {
                $state.go(Constant.STATE.APP.PATIENT.LIST);
            });

            $scope.$on(Event.NFZ_OFFICE.GET_DATA_PAGE.SUCCESS, function(event, dataPage) {
                $scope.nfzOfficeList = dataPage.data;
            });
        }

        function setActions() {

            $scope.savePatientData = function () {
                $scope.forms.personalData.$setSubmitted();

                if($scope.forms.personalData.$valid) {
                    patientModel.save($scope.patient);
                }
            };

            $scope.addAuthorizedPerson = function() {
                $mdDialog.show({
                    templateUrl: 'edm/application/view/app/patient/popup/popup-authorized-person.html',
                    controller: 'popupAuthorizedPersonController',
                    resolve: {
                        authorizedPersonData: function() {
                            return null;
                        }
                    }
                }).then(function(data) {
                    $scope.patient.authorizedPersons.push(data);
                }, function(error){

                });
            };

            $scope.deleteAuthorizedPerson = function(authorizedPerson) {
                var confirm = $mdDialog.confirm({
                    title: $translate.instant('T.MODULE.VISIT.AUTHORIZED_PERSON_DELETE_CONFIRMATION'),
                    ok: $translate.instant('T.UI.APPLICATION.YES'),
                    cancel: $translate.instant('T.UI.APPLICATION.NO')
                });
                $mdDialog.show(confirm).then(function() {
                    _.remove($scope.patient.authorizedPersons, function (person) {
                        return person === authorizedPerson
                    })
                }, function() {
                    return false;
                });
            };

            $scope.editAuthorizedPerson = function(authorizedPerson) {
                $mdDialog.show({
                    templateUrl: 'edm/application/view/app/patient/popup/popup-authorized-person.html',
                    controller: 'popupAuthorizedPersonController',
                    resolve: {
                        authorizedPersonData: function() {
                            return authorizedPerson;
                        }
                    }
                }).then(function(data) {
                    var mapped = $scope.patient.authorizedPersons.map(function(element) { return element.id });
                    var index = mapped.indexOf(data.id);

                    if(index != -1) {
                        $scope.patient.authorizedPersons[index] = data;
                    } else {
                        $scope.patient.authorizedPersons.push(data);
                    }
                }, function(error){

                });
            };

            $scope.enclose = function (fileInput) {
                if(fileInput.length > 0) {
                    fileInput.forEach(function(element) {
                        $scope.fileList.push({ loaded: false, data: element})
                    });
                }
            };

            $scope.deleteAttachmentFile = function(fileToDelete) {
                _.remove($scope.fileList, function (file) {
                    return file === fileToDelete;
                })
            };

            $scope.clonePatientAddressData = function() {
                $scope.patient.correspondenceAddressSameAsRegisteredAddress = !$scope.patient.correspondenceAddressSameAsRegisteredAddress;
                if($scope.patient.registeredAddress) {
                    $scope.patient.correspondenceAddress = (!$scope.patient.correspondenceAddressSameAsRegisteredAddress) ? angular.copy($scope.patient.registeredAddress) : $scope.patient.registeredAddress;
                }
            }
        }

        function configureInterface() {
        }

        function initialize() {
            applicationModel.viewReady = true;
            var criteria = {};
            dictionaryModel.getDictionaryElementsDataPage(Constant.DICTIONARY_CODE.CITIZENSHIP, criteria);
            dictionaryModel.getDictionaryElementsDataPage(Constant.DICTIONARY_CODE.STATE, criteria);
            nfzOfficeModel.getDataPage(criteria);
        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);
